/**
 * `auth:trial_requested` — the trial funnel's "requested" stage, fired from
 * EVERY surface that starts a trial, not only the onboarding dialog (round-2
 * review): Settings → License's "Start Trial" and the trial-expiry dialog's
 * extension request start one too, and a funnel that only counted the dialog
 * under-reported requests against `auth:trial_start_server { kind: 'new' }`.
 * `entry` says which surface; `authenticated` whether sign-in still has to
 * happen first. No PII.
 */

export type TrialRequestEntry = 'onboarding' | 'settings' | 'expiry_dialog';

export function trackTrialRequested(entry: TrialRequestEntry, authenticated: boolean): void {
  window.electronAPI?.analytics
    ?.track('auth:trial_requested', { entry, authenticated })
    .catch(() => {});
}
